<template>
  <CSidebar
    class="help-center-sidebar"
    overlaid
    :unfoldable="false"
    placement="end"
    :visible="$store.state.layout.asideShow"
    color-scheme="light"
    size="lg"
    @visible-change="
      (value) => $store.commit('layout/set', ['asideShow', value])
    "
  >
    <CCloseButton @click="closeAsideBar()" />
    <template v-if="isLoading">
      <div class="d-flex justify-content-center my-6">
        <CSpinner color="primary" />
      </div>
    </template>
    <template v-else>
      <div
        v-if="helpCenterContent"
        data-test-id="cy-help-center-sidebar"
        class="help-center-content pt-5"
        tabindex="-1"
      >
        <CustomScrollbar>
          <div class="ps-4 pe-5" v-html="helpCenterContent"></div>
        </CustomScrollbar>
      </div>
    </template>
  </CSidebar>
</template>

<script>
import { reactive, computed } from "vue"
import { useStore } from "vuex"

export default {
  name: "TheAside",
  setup() {
    const store = useStore()

    const state = reactive({
      scrollbarSettings: {
        suppressScrollY: false,
        suppressScrollX: true
      }
    })

    const helpCenterContent = computed(
      () => store.getters["helpCenter/getHelpCenterContent"]
    )

    const isLoading = computed(
      () => store?.state?.helpCenter?.isLoading || false
    )

    const closeAsideBar = () => {
      store.commit("layout/toggle", "asideShow")
      store.commit("helpCenter/SET_CONTENT", "")
    }

    return {
      state,
      helpCenterContent,
      closeAsideBar,
      isLoading
    }
  }
}
</script>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: calc(100vh - 200px);
}
</style>
